import { createContext } from 'react'

export const AppContext = createContext<{
  isTablet: boolean | undefined
}>({
  isTablet: undefined,
})
